// Port of api/fuel/app/classes/insights/shelf/after.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'

export default Segment.extend({
	name: 'after',
	requires: ['longest'],
	insight: false,
	run: function(type, owner, userIndex, detail, filter, vars) {
		var specific = vars && vars.specific ? vars.specific : false
		var after = []
		var labels = ['< 10 days', '< 100 days', '< 1 year', '> 1 year']

		for (var i = 0; i < labels.length; i++) {
			after.push(specific ? [] : {
				name: labels[i],
				games: 0,
				playsAverage: 0,
				playsCount: 0,
				collectionPercent: 0,
				collectionCount: 0,
				ratingAverage: 0,
				ratingCount: 0,
				ratingTotal: 0
			})
		}

		var gameIndex = (this._data.longest || []).filter(function(item) { return item.played }).map(function(item) { return parseInt(item.id, 10) })
		if (gameIndex.length) {
			var ratings = Util.queryFast(
				'SELECT r.game_id AS g, r.rating_value AS r FROM rating r WHERE r.user_id = ' + owner.get_id() +
				' AND r.game_id IN (' + Util.in(gameIndex) + ')',
				null,
				'g'
			)

			for (var j = 0; j < this._data.longest.length; j++) {
				var item = this._data.longest[j]
				if (!item.played) continue

				var days = Math.floor(item.length / 86400)
				var index = 0
				if (days >= 365) index = 3
				else if (days >= 100) index = 2
				else if (days >= 10) index = 1

				if (specific) {
					after[index].push(item)
				} else {
					after[index].games++
					after[index].playsCount += item.plays

					if (ratings[item.id]) {
						after[index].ratingCount++
						after[index].ratingTotal += parseFloat(ratings[item.id].r)
						after[index].ratingAverage = after[index].ratingTotal / after[index].ratingCount
					}

					if (item.own) after[index].collectionCount++
					if (after[index].collectionCount) after[index].collectionPercent = (100 / after[index].games) * after[index].collectionCount
					if (after[index].playsCount) after[index].playsAverage = Math.round((after[index].playsCount / after[index].games) * 10) / 10
				}

				this._references.games.push(parseInt(item.id, 10))
			}
		}

		if (specific) after = after[specific - 1]

		return {
			after: after
		}
	}
})
